import { apiPost } from '../../api'

export const save_curriculum = data =>
  apiPost({
    endpoint: 'curriculums/save_curriculum',
    data
  })
